<a href="#main-content" class="skip-to-content" onclick="event.preventDefault(); var el=document.getElementById('main-content'); if(el){el.focus();}">Skip to main content</a>

<main id="main-content" tabindex="-1">
  <section *ngIf="isLoading" aria-live="polite" aria-busy="true">
    <mat-card>
      <div>
        <mat-spinner color="primary" aria-hidden="true"></mat-spinner>
        <p class="sr-only">Loading Ohio EPA payment service. Please wait.</p>
      </div>
    </mat-card>
  </section>

  <section *ngIf="!isLoading">
    <mat-card>
      <header class="page-header">
        <a href="https://epa.ohio.gov" target="_blank" rel="noopener" tabindex="0" aria-label="Ohio EPA Homepage">
          <img class="epa-logo" [src]="ebizRootURL + '/DownloadEPALogo'" alt="Ohio Environmental Protection Agency Logo" />
        </a>
        <h1 class="payment-title" [title]="versionNumber">{{ account ? 'Payment Service' : 'Guest Payment' }}</h1>
      </header>

      <!-- GUEST INFORMATION -->
      <section *ngIf="!account" aria-labelledby="guest-info-title">
        <h2 id="guest-info-title">Online Invoice Payment</h2>
        <p>
          Most Ohio EPA invoices may be paid with a credit card. Customers can pay multiple receivables of the same type at
          one time in batches of 20 or fewer.
        </p>
          
        <p>
          We accept Master Card, Visa, or Discover. A service fee of 1.9% will be added to all payments. Your credit card
          statement will show the invoice payment and a separate service fee. All online transactions are processed as
          one-time payments. Ohio EPA does not save your credit card information.
        </p>

        <p>
          For information on additional payment options, please visit
           <a href="https://epa.ohio.gov/payfees">epa.ohio.gov/payfees</a>.
        </p>

        <p>
          If you need assistance, please call our Fiscal office, Monday - Friday between 8 a.m. and 5 p.m. (closed on
          holidays) at 614.644.2339.
        </p>
      </section>

      <!-- ACCOUNT HOLDER INFORMATION -->
      <section *ngIf="account" aria-labelledby="account-info-title">
        <h2 id="account-info-title"> Payment Information</h2>
        <div class="info-container">  
           <!-- info-icon-cell info-description-cell-->
          <mat-icon aria-hidden="true">info_outline</mat-icon>
          <p>
            Most invoices issued by Ohio EPA may be paid online with one of the credit cards
            listed below or by debiting
            your bank account through the Automated Clearing House (ACH). All online transactions are processed as one
            time payments. Ohio EPA does not save your credit card or bank account information.
            If you need assistance please call our Fiscal office, Mon. - Fri. between 8 AM and 5 PM (closed on holidays)
            at (614) 644-2339.
          </p>
        </div>
      </section>

      <!-- PAYMENT METHODS -->
      <section *ngIf="account" aria-labelledby="payment-methods-title">
        <h2 id="payment-methods-title">Payment Methods</h2>
        <section aria-labelledby="credit-card-title">
          <h3 id="credit-card-title">Master Card, VISA or Discover Credit Card</h3>
          <p>
            Any eBusiness account holder can pay using a credit card; you do not need a PIN. A service fee of
            1.9% is added to payments made by credit card. Your credit card statement will show two payments,
            the invoice payment and a separate service fee.
          </p>
        </section>

        <section aria-labelledby="ach-title">
          <h3 id="ach-title">Automated Clearing House (ACH)</h3>
           <p>
            Ohio EPA eBusiness account holders must have an Ohio EPA PIN to pay by ACH (electronic check) from your bank
            account. There is no service fee for ACH payments. Some bank accounts have a debit block or filter that rejects
            ACH payments. Please contact your bank if you think a debit block may be in place and ask your bank to modify
            or remove it before you pay using ACH.
          </p>
        </section>

        <section aria-labelledby="mail-title">
          <h3 id="mail-title">Check or Money Order via US Mail</h3>
          <p>
            If your invoice has a bar code at the bottom you may pay by check/money order, payable to Treasurer, State of
            Ohio,
            by mailing the check/money order and the bottom portion of the invoice with the bar code to Ohio EPA, PO Box
            77005,
            Cleveland, Ohio 44194-7005. Sending payments without a bar code on the invoice to the Cleveland location will
            result in a processing delay.
          </p>

          <p>
            If your invoice does not have a bar code, please include a copy of the invoice with your check/money order and
            mail to Ohio EPA, PO Box 1049, Columbus Ohio 43215-1049. Please record the Revenue ID Number from the invoice
            on your check/money order.
          </p>

          <p>
            All checks/money orders should be made payable to "Treasurer, State of Ohio".
          </p>
        </section>

        <section aria-labelledby="agency-title">
          <h3 id="agency-title">State Agency ISTV Payment</h3>
          <p>
            State agencies wishing to pay an invoice by ISTV may contact Ohio EPA Fiscal Administration at 614-644-2339.
          </p>
        </section>

        <section aria-labelledby="multiple-title">
          <h3 id="multiple-title">Paying Multiple Receivables</h3>
          <p>
            Customers who choose to pay multiple receivables at one time can do so in batches of 20 receivables. The system
            cannot process more than 20 receivables at <span class="oepa-red-text">one</span> time.
          </p>
        </section>
      </section>

      <div *ngIf="showRecaptcha" aria-live="assertive" class="sr-only">
        Security verification required.
      </div>
      <section tabindex="-1" aria-labelledby="captcha-title" class="recaptcha">
        <h2 id="captcha-title" class="sr-only">Security verification</h2>
        <span id="recaptcha-description" class="sr-only">Please complete the reCAPTCHA challenge before continuing.</span>
        <re-captcha [class.hidden]="!showRecaptcha" (resolved)="resolved($event)" [siteKey]="recaptchaSiteKey" aria-describedby="recaptcha-description"></re-captcha>
      </section>

      <nav class="action-buttons" aria-label="Payment actions">
        <p *ngIf="!account && !showRecaptcha" class="button-item">Click this button to get started!</p>
        <button *ngIf="!account" class="button-item" mat-flat-button id="ext_openSearch_btn" (click)="openSearchDialog()" [disabled]="showRecaptcha">Find and Pay Invoice</button>
        <button *ngIf="account" class="button-item" mat-flat-button id="int_openSearch_btn" (click)="openSearchDialog()">Lookup Invoice to Pay Online</button>
        <button *ngIf="showRequestPin" class="button-item" mat-flat-button id="int_pinRequest_btn" (click)="openPinRequest()">Request PIN</button>
        <button *ngIf="account" class="button-item" mat-flat-button id="int_exit_btn" (click)="exit()">Exit</button>
      </nav>
    </mat-card>
  </section>
</main>
